import MembershipShippingAddress from "components/source/membership/membership-shipping-address";
import PropTypes from "prop-types";

export default function AddressUpdater({ saveZipToWorkingFilter }) {
  const saveZipFilters = address => {
    const zip_code = address.postalCode;
    saveZipToWorkingFilter({ zip_code });
  };

  return <MembershipShippingAddress onClickUseAddress={saveZipFilters} onNewAddressAdded={saveZipFilters} />;
}

AddressUpdater.propTypes = {
  saveZipToWorkingFilter: PropTypes.func,
};
